import Vue from "vue";
import { Plugin } from "vue-fragment";
import axios from "axios";
// import { hexAToHSLA } from './utils/utils';

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(Plugin);

Vue.config.productionTip = false;

//const subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
let subdomain, authenticated, organisation;

if (process.env.NODE_ENV === "development") {
  subdomain = "reinhelpt";
  authenticated = false;
} else {
  subdomain = window.location.host.split(".")[1]
    ? window.location.host.split(".")[0] === "www"
      ? "reinhelpt"
      : window.location.host.split(".")[0]
    : false;
  authenticated = false;
}

axios
  .get(
    `https://icy-canyon-zkyzx0ltwf.ploi.link/api/verify-organisation/${subdomain}`
  )
  .then((response) => {
    const data = response.data;
    organisation = data;
    let persistedState = JSON.parse(localStorage.getItem("vuex"));
    if (!persistedState) {
      persistedState = { authenticated: false };
    }

    const savedOrganisation = localStorage.getItem("organisation");
    if (savedOrganisation === "demo") {
      persistedState.authenticated = false;
      localStorage.setItem("vuex", JSON.stringify(persistedState));
      localStorage.removeItem("organisation");
    }

    if (!data.has_auth || persistedState.authenticated) {
      authenticated = true;
    }

    initializeVue();
  })
  .catch((error) => {
    console.log(error);
    // initializeVue()
  });

function initializeVue() {

  window.localStorage.setItem("initial_url", window.location.href);
  store.state.authenticated = authenticated;
  store.state.organisation = organisation;
  store.state.themeslug = `${subdomain}-`;
  window.app = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
